import axios from 'axios';
import { AddEmployeeNoteParams } from 'components/employee-portal/notes/hooks/useAddEmployeeNote.types';
import { EMPLOYEE_NOTES, REMOVE_EMPLOYEE_NOTES } from 'RestAPIs/endpoints';

export interface EmployeeNotesResponse {
  content: string;
  creationDate: string;
  creationEmployeeNumber: number;
  creationUser: string;
  flags: string[];
  noteId: number;
  refId: number;
  type: string;
}

export interface NewEmployeeNote {
  content: string;
}

export const getEmployeeNotes = ({ employeeId }: { employeeId: number }) =>
  axios.get<EmployeeNotesResponse[]>(EMPLOYEE_NOTES, {
    pathParams: { employeeId }
  });

export const addEmployeeNote = ({ employeeId, body }: AddEmployeeNoteParams) =>
  axios.post<NewEmployeeNote>(EMPLOYEE_NOTES, body, {
    pathParams: { employeeId }
  });

export const removeEmployeeNote = ({ noteId }: { noteId: number }) =>
  axios.delete(REMOVE_EMPLOYEE_NOTES, {
    pathParams: { noteId }
  });
